import { Link, useOutletContext } from 'react-router';
import {
  AuthHeader,
  NewPasswordForm,
  OTPForm,
  PasswordResetForm,
  ResetPasswordSuccessful,
} from './components';
import { routes } from '@/lib/constants';
import { useState } from 'react';
import type { OutletContext } from '@/components/layouts';

export const ForgotPasswordPage = () => {
  const [identifier, setIdentifier] = useState<string>('');
  const [otpCode, setOtpCode] = useState<string>();

  const { step, decrementStep } = useOutletContext<OutletContext>();

  return (
    <div className="flex flex-col gap-10 overflow-y-auto w-full">
      {step === 0 && (
        <AuthHeader
          heading="Reset your password"
          description="Enter your email to reset your password and regain access in no time!"
        />
      )}
      {step === 2 && (
        <AuthHeader
          heading="Verify your email"
          description="Enter the verification code sent to your email"
        />
      )}
      {step === 3 && (
        <AuthHeader
          heading="Create new password"
          description="Enter a new password for your account"
        />
      )}
      {step === 4 && <ResetPasswordSuccessful />}
      {step === 0 && <PasswordResetForm setIdentifier={setIdentifier} />}
      {step === 2 && (
        <OTPForm identifier={identifier} setOtpCode={setOtpCode} />
      )}
      {step === 3 && <NewPasswordForm otpCode={otpCode} />}
      <div
        className="text-xs md:text-sm px-4 md:px-6 lg:px-8 -mt-6"
        onClick={() => decrementStep(step)}
      >
        Already have an account?{' '}
        <Link to={routes.login} className="text-primary">
          Sign in
        </Link>
      </div>
    </div>
  );
};
